import { customColors } from '../../utilities';
import Icon from '../Icon';
import { Text } from '../typography';
import { useTranslation } from 'react-i18next';
import styles from './Dropdown.module.scss';

export default function TypeOption({ type }) {
  const { t } = useTranslation();

  return (
    <div className={styles.typeContainer}>
      {type?.icon && (
        <Icon
          style={{
            color: customColors[type?.color?.toUpperCase()] || type?.color,
          }}
        >
          {type.icon}
        </Icon>
      )}
      <Text noMargin weight="semiBold">
        {t(type?.title) || type?.title || type?.name}
      </Text>
    </div>
  );
}
